import React from 'react'
import TableWidget10 from './TableWidget10'
import stocks from '../json/stocks.json'

const SampleTableWidget10 = () => <TableWidget10 items={stocks} />

export default SampleTableWidget10
